var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCancelBidSolid = function SvgCancelBidSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8.684.21.092.08.002-.002 6.364 6.364-.002.002c.363.363.39.93.085 1.323l-.083.094a1 1 0 0 1-1.32.083l-.094-.083-2.121 2.121 3.535 3.536a1 1 0 0 1-1.32 1.497l-.094-.083-3.536-3.535-2.12 2.12a1 1 0 0 1-1.32 1.498l-.095-.083-.707-.707L1 9.485l-.707-.707a1 1 0 0 1 1.32-1.497l.092.08 5.657-5.656A1 1 0 0 1 7.281.387l.083-.094A1 1 0 0 1 8.684.21ZM9.85 5.607a1 1 0 0 0-1.414 0L5.607 8.436A1 1 0 0 0 7.021 9.85L9.85 7.02a1 1 0 0 0 0-1.414Z"
  })));
};
export default SvgCancelBidSolid;